import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "servicios",
  class: "relative scroll-mt-20 overflow-hidden py-28 md:py-36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute left-1/2 top-0 h-[500px] w-[800px] -translate-x-1/2 rounded-full bg-copper/5 blur-3xl" }, null, -1)
const _hoisted_3 = { class: "relative mb-16 flex flex-col gap-6 md:mb-20 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_4 = { class: "eyebrow" }
const _hoisted_5 = { class: "section-title mt-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-molten" }, "Servicios", -1)
const _hoisted_7 = { class: "max-w-md text-ivory/50 lg:text-right" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" }

import CardComponent from "@/components/base/CardComponent.vue";
import ContainerComponent from "@/components/base/ContainerComponent.vue";
import { services } from "@/data/services";

export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createTextVNode("Lo que hacemos")
            ])), [
              [_directive_reveal]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_5, [
              _createTextVNode(" Nuestros "),
              _hoisted_6
            ])), [
              [_directive_reveal, 100]
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createTextVNode(" Del metal fundido a la pieza terminada, y todo lo que la acompaña: grabado, bordado, sublimación e impresión 3D bajo un mismo techo. ")
          ])), [
            [_directive_reveal, 200]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: service.title
            }, [
              _createVNode(CardComponent, {
                "image-src": service.src,
                "card-title": service.title,
                text: service.text,
                index: i + 1
              }, null, 8, ["image-src", "card-title", "text", "index"])
            ])), [
              [_directive_reveal, (i % 4) * 90]
            ])
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})